import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ServicesLink from '../../components/Sections/MainPage/ServicesLink';
import ProjectInfo from '../../components/Sections/ProjectDetails/ProjectInfo';
import Notifications from '../../components/Sections/ProjectDetails/Notifications';
import { browserHistory } from 'react-router';

class ProjectDetails extends React.Component {
  constructor(props) {
    super(props);
    props.initAPI();
    this.state = { isDataLoaded: false };
  }

  componentWillReceiveProps(p) {
    if (p.user && !p.user.isAuthenticated) {
      browserHistory.push('/login');
      return;
    }
    if (p.user && p.user.isAuthenticated && !this.state.isDataLoaded) {
      this.getProjectDetails();
      this.setState({ isDataLoaded: true });
    }
    if (p.addEmailSuccess && p.addEmailSuccess.isSuccess) {
      this.getProjectDetails();
      p.resetAddEmailSuccess();
    }
    if (p.deleteEmailSuccess && p.deleteEmailSuccess.success) {
      this.getProjectDetails();
      p.resetDeleteEmailSuccess();
    }
    if (p.updateNotificationSuccess && p.updateNotificationSuccess.isSuccess) {
      this.getProjectDetails();
      p.resetUpdateNotificationSuccess();
    }
  }

  goBack = () => {
    browserHistory.push('/dashboard');
  };

  getProjectDetails = () => {
    const p = this.props;
    if (p && p.projectNo) {
      const model = {
        IsWeb: true,
        ProjectNo: p.projectNo,
        ApplicationType: p.appType
      };
      p.getProjectDetails(model);
    }
  };
  
  render() {
    const p = this.props.project;

    const cl = window.osa && window.osa.commonLookup && window.osa.commonLookup;
    return (
      <div>
        <div className="container">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <ServicesLink lookup={cl && cl.services} />
        </div>
          <div className="col-sm-12 border sidebarTop">
            <h3>Service requests</h3>
            {
              p && p.status == 'Submitted' && p.isWeb ?
                <Notifications />
                :
                null
            }
            {p ? <ProjectInfo project={p} /> : null}
          </div>
           
        </div>
        <br />
        <a id="linkBack" href="/dashboard" className="fortis-Button">Back to Service requests</a>
      </div>
    );
  }
}


ProjectDetails.propTypes = {
  user: PropTypes.object,
  projectNo: PropTypes.string,
  appType: PropTypes.string,
  project: PropTypes.object,
  emailList: PropTypes.object,
  initAPI: PropTypes.func
};

function mapStateToProps(state) {
  return {
    form: state.form,
    user: state.gas.user,
    project: state.gas.projectDetails && state.gas.projectDetails.data,
    addEmailSuccess: state.gas.addEmailSuccess,
    deleteEmailSuccess: state.gas.deleteEmailSuccess,
    updateNotificationSuccess: state.gas.updateNotificationSuccess,
    projectNo: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["projectNo"],
    appType: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["appType"]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    initAPI: () => {
      dispatch({ type: 'INITIALIZE_PROJECTDETAILS' });
      dispatch({ type: 'INITIALIZE_API' });
    },
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    getProjectDetails: (model) => dispatch({ type: 'GET_PROJECT', model }),
    resetAddEmailSuccess: () => dispatch({ type: 'ADD_EMAIL_SUCCESS', data: null }),
    resetDeleteEmailSuccess: () => dispatch({ type: 'DELETE_EMAIL_SUCCESS', data: null }),
    resetUpdateNotificationSuccess: () => dispatch({ type: 'UPDATE_NOTIFICATION_SUCCESS', data: null })
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);